import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

/**
 * Modal shown when the user clicks an upstream incident they cannot access.
 * Lists domains that do have access so they can request permissions.
 */
import SModal from '@/components/SModal.vue';
import SEmptyState from '@/components/SEmptyState/SEmptyState.vue';
import SButton from '@/components/SButton/SButton.vue';

interface IncidentRestrictedAccessModalProps {
  associatedDomainNames?: string[] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IncidentRestrictedAccessModal',
  props: {
  associatedDomainNames: { default: null }
},
  setup(__props, { expose }) {

const props = __props;


const modal = _ref<InstanceType<typeof SModal> | null>(null);

const domainsLabel = _computed(() => {
  const domains = props.associatedDomainNames ?? [];
  if (!domains.length) return '';
  return `${domains.join(', ')}`;
});

const openModal = (): void => {
  modal.value?.openModal();
};
const closeModal = (): void => {
  modal.value?.closeModal();
};

expose({ openModal, closeModal });

return { __sfc: true,props, modal, domainsLabel, openModal, closeModal, _ref, _computed, SModal, SEmptyState, SButton }
}

})